import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

function UnauthorizedPage() {
  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <Card className="h-[300px] w-[400px] rounded shadow-[0_0_10px_rgba(0,0,0,0.1)]">
        <CardContent className="flex h-full flex-col items-center justify-between p-5">
          <div>
            <p className="m-0 mb-5 text-center text-xl font-medium text-inherit">
              404
            </p>
          </div>
          <div>
            <p className="m-0 mb-5 text-center text-xl font-medium text-inherit">
              Page Not Found
            </p>
            <p className="m-0 mb-5 text-center text-[15px] font-medium text-inherit">
              Unable to load the requested page or the session id is not valid
            </p>
          </div>
          <Button
            onClick={() =>
              (window.location.href = "https://app.smartai.com.au")
            }
            className="h-10 w-1/2 rounded bg-black px-2.5 text-[15px] font-normal text-white hover:bg-black/90"
          >
            Go to Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default UnauthorizedPage;
